export function useDateFormater() {
  return (reqDate, withTime) => {
    let tempDate = new Date(reqDate);
    let date = tempDate.getDate();
    let month = tempDate.getMonth();
    let year = tempDate.getFullYear();

    let newDate;
    newDate = `${year}/${month + 1}/${date}`;

    if (withTime === true) {
      newDate = `${newDate}T${new Date(reqDate).toLocaleTimeString('it-IT')}`;
    }

    return newDate;
  };
}
